import { DetailsCard } from "components";
import { SnoozedItemsHistoryTable, SnoozedItemsTable } from "modules/AppointmentDetails/components/SnoozedItems/components";
import { useSnoozedItemsHistory } from "modules/AppointmentDetails/components/SnoozedItems/components/SnoozedItemsHistoryTable/hooks";
import "modules/AppointmentDetails/components/SnoozedItems/SnoozedItems.scss";

import type { SectionMenu } from "components";
import type { Appointment, CarCheck, Intervention, QuestionResult } from "models";

type SnoozedItemsProps = {
  isExpanded: boolean;
  sectionMenu: SectionMenu;
  appointment: Appointment;
  checks?: CarCheck[];
};

const getSnoozedInterventions = (interventions: Intervention[] = []) => interventions.filter(i => i.snoozed);

const getSnoozedQuestionResults = (checks: CarCheck[] = []) =>
  checks.reduce<QuestionResult[]>(
    (questions, check) => (!check.checklist?.template?.snooze_enabled ? questions : questions.concat(check.question_items?.filter(q => q.snoozed) ?? [])),
    []
  );

export const getSnoozedItemsCount = (interventions: Intervention[] = [], checks: CarCheck[] = []) =>
  getSnoozedInterventions(interventions).length + getSnoozedQuestionResults(checks).length;

export const SnoozedItems = ({ isExpanded, sectionMenu, appointment, checks }: SnoozedItemsProps) => {
  const { paginatedSnoozedItemsHistory, loading, setPage } = useSnoozedItemsHistory(appointment.id);

  const snoozedQuestionItems = getSnoozedQuestionResults(checks);
  const snoozedInterventions = getSnoozedInterventions(appointment.interventions);

  if (!sectionMenu.count && !paginatedSnoozedItemsHistory?.items.length) return null;

  return (
    <DetailsCard
      icon={sectionMenu.icon}
      sectionMenuId={sectionMenu.id}
      isExpanded={isExpanded}
      title={sectionMenu.count ? `${sectionMenu.title} (${sectionMenu.count})` : sectionMenu.title}
    >
      <SnoozedItemsTable appointment={appointment} snoozedQuestionItems={snoozedQuestionItems} snoozedInterventions={snoozedInterventions} />
      <SnoozedItemsHistoryTable appointment={appointment} paginatedSnoozedItemsHistory={paginatedSnoozedItemsHistory} loading={loading} setPage={setPage} />
    </DetailsCard>
  );
};
